module.exports = __webpack_public_path__ + "static/media/ordenacaodesc.3bd88e50.svg";